import { useEffect, useState } from "react";
import { getUserAssetDetail } from "@apis/http/api";
import { mapAssetPreviewUrls } from "./mapAssetPreviewUrls";

export interface UsePostToTikTokAssetVideoOptions {
  assetId: number;
  enabled: boolean;
}

export const usePostToTikTokAssetVideo = ({ assetId, enabled }: UsePostToTikTokAssetVideoOptions) => {
  const [fetched, setFetched] = useState<{ videoUrl?: string; posterUrl?: string }>({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled || assetId <= 0) {
      setFetched({});
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    void getUserAssetDetail({ assetId })
      .then((detail) => {
        if (cancelled) return;
        setFetched(mapAssetPreviewUrls(detail));
      })
      .catch(() => {
        if (cancelled) return;
        setFetched({});
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [assetId, enabled]);

  return {
    videoUrl: fetched.videoUrl,
    posterUrl: fetched.posterUrl,
    loading: enabled && assetId > 0 && loading && !fetched.videoUrl,
  };
};
